import ApiService from "@/services/api.service";

export async function getBillNew(billRequest) {
        return await ApiService.betterPost("ticket/order/bill/new", billRequest);
}